import type { Lang } from './i18n/index.js';

/**
 * The reader's language choice, remembered between visits.
 *
 * It is stored rather than held in memory because the choice is made on the
 * welcome screen, before signing in, and the browser leaves this site entirely
 * to reach the Microsoft sign-in page. Without somewhere to keep it, everyone
 * who picked English would be handed Arabic again on the way back.
 *
 * The default is Arabic. This is an Arabic-first service; English is the
 * translation, not the other way round.
 */

const KEY = 'cfoai.lang';

export function readLang(): Lang {
  try {
    return window.localStorage.getItem(KEY) === 'en' ? 'en' : 'ar';
  } catch {
    // Private browsing, or storage refused. A default is a perfectly good answer.
    return 'ar';
  }
}

export function writeLang(lang: Lang): void {
  try {
    window.localStorage.setItem(KEY, lang);
  } catch {
    // Not worth failing a language toggle over.
  }
}
